import psHttp from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix } from '../../config/constants';

export function setWordingApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/wording`,
        method: 'POST',
        headers: {
            'X-API-Version': '1.0'
        },
        data
    });
}

export function removeWordingApi(wordId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/wording/${wordId}`,
        method: 'DELETE',
        headers: {
            'X-API-Version': '1.0',
            'content-type': 'application/json;charset=utf-8'
        },
        data: {}
    });
}
